import React from 'react';
import { Row, Col, Divider } from 'antd';
import moment from 'moment';

import * as S from './styles';

export function HistoricoAnalise({ historico = [] }) {
  return (
    <Col md={24} lg={24} xs={24}>
      <Row md={24} lg={24} xs={24}>
        <S.TituloHitorico
          status="warning"
          text="Observações de análises anteriores:"
        />
      </Row>
      {historico?.map((item, index) => (
        <Col key={index} style={{ marginTop: '24px' }} md={24} lg={24} xs={24}>
          <Row>
            <S.TituloAnalise>
              {(item?.dataAtendimentoAnterior &&
                moment(item?.dataAtendimentoAnterior).format(
                  'DD/MM/YYYY [às] HH:mm:ss'
                )) ||
                ''}
            </S.TituloAnalise>
          </Row>
          <Row style={{ marginTop: '8px' }}>
            <S.ContentAnalise>
              <S.AnaliseDescrita>
                <pre>{item?.observacao || ''}</pre>
              </S.AnaliseDescrita>
            </S.ContentAnalise>
          </Row>
        </Col>
      ))}
      <Divider
        type="horizontal"
        style={{
          border: '1px solid #BDBDBD',
          backgroundColor: '#BDBDB',
        }}
      />
    </Col>
  );
}
